import { Cart } from "./products/cart/models/cart";
import { CartButton } from "./products/cart/views/cart-button";
// import { CartMessages } from "./products/cart/views/cart-messages";

(function($){
	
	$(document).ready(function(){
        var cart = new Cart();

        window.cart = cart;

        // var c = new CartMessages({ model: cart, el: $('#cart-messages') });
        // c.render();

        $( 'a.basket' ).each( function(){
            let button = new CartButton({el: $(this), model: cart});
            button.updateCountBadge();
        });
        $( window ).trigger('cart-ready');

        // button.remove();

    });
})(jQuery);